module.exports = __webpack_public_path__ + "static/media/find us on facebook.90094e35.png";